import type { ProductCostParity, SoldCostMonth, SoldCostMonthLeaf, SoldCostProduct } from "./api";

export function productCostLeaf(month: SoldCostMonth): SoldCostMonthLeaf | null {
  return month.leaves.find((leaf) => leaf.treatment === "item_source") ?? null;
}

export function productCostRows(month: SoldCostMonth): SoldCostProduct[] {
  return (productCostLeaf(month)?.products ?? []).filter((row) => row.per_unit_gbp !== undefined);
}

export function productCostParity(month: SoldCostMonth): ProductCostParity | null {
  return month.run?.detail.parity ?? null;
}

export function productCostTotal(rows: SoldCostProduct[]): string {
  const pence = rows.reduce((sum, row) => sum + Math.round(Number(row.product_amount_gbp) * 100), 0);
  return (pence / 100).toFixed(2);
}

export function isCase(row: SoldCostProduct): boolean {
  return row.qty !== undefined && Number(row.qty) !== row.units;
}
